var map = {
	"./Accordion.svg": 567,
	"./Breadcrumb.svg": 568,
	"./Button.svg": 569,
	"./Checkbox.svg": 570,
	"./Code snippet.svg": 571,
	"./Content switcher.svg": 572,
	"./Data table.svg": 573,
	"./Date picker.svg": 574,
	"./Dropdown.svg": 575,
	"./File uploader.svg": 576,
	"./Form.svg": 577,
	"./Inline loading.svg": 578,
	"./Link.svg": 579,
	"./List.svg": 580,
	"./Loading.svg": 581,
	"./Modal.svg": 582,
	"./Multiselect.svg": 583,
	"./NoImage.svg": 361,
	"./Notification.svg": 584,
	"./Number input.svg": 585,
	"./Overflow menu.svg": 586,
	"./Pagination.svg": 587,
	"./Progress indicator.svg": 588,
	"./Radio button.svg": 589,
	"./Search.svg": 590,
	"./Select.svg": 591,
	"./Slider.svg": 592,
	"./Structured list.svg": 593,
	"./Tabs.svg": 594,
	"./Tag.svg": 595,
	"./Text input.svg": 596,
	"./Tile.svg": 597,
	"./Toggle.svg": 598,
	"./Tooltip.svg": 599,
	"./UI shell.svg": 600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 566;